export default "__VITE_ASSET__aca253b2__"